import { render, staticRenderFns } from "./IframeCMP.vue?vue&type=template&id=46af56ad"
import script from "./IframeCMP.vue?vue&type=script&lang=js"
export * from "./IframeCMP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports